// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__1_QWw","about":"about_about__eBBMg","container_image":"about_container_image__2cjrK"};